<div class="flex flex-col gap-20 justify-center align-center mt-90 mr-20 ml-20">
      <h1 style="font-size: 50px" class="m-0">Oops!</h1>
      <div class="mr-20 ml-20"><h4 class="fs-20 m-0">Something went wrong on our end. It's not you - it's us.</h4></div>
      <div class="mt-30 flex gap-20">
        <button id="btnTryAgain" mat-flat-button type="button" class="primary-btn" (click)="tryAgain()">
          Try Again
        </button>
      </div>
</div>
